import { FC } from 'react';
import { Entity } from '@backstage/catalog-model';
import { JsonObject } from '@backstage/types';
import { Box, Tooltip, Typography, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  avatar: {
    width: '32px',
    height: '32px',
    minWidth: '32px',
    minHeight: '32px',
    pointerEvents: 'none',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'contain',
    borderRadius: theme.spacing(1),
    border: `1px solid ${theme.palette.grey[200]}`,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));

interface Props {
  entity: Entity;
}

export const ComponentIcon: FC<Props> = ({ entity }) => {
  const classes = useStyles();
  const title = entity.metadata.title || entity.metadata.name;
  const icon = (entity.metadata?.mesh as JsonObject | undefined)
    ?.icon as string;

  return (
    <Tooltip title={title}>
      <div>
        <Box
          className={classes.avatar}
          style={{
            backgroundImage: icon ? `url(${icon})` : '',
          }}
        >
          {!icon && (
            <Typography>
              {title
                .split(' ')
                .slice(0, 2)
                .map(s => s.charAt(0))}
            </Typography>
          )}
        </Box>
      </div>
    </Tooltip>
  );
};
